import React from 'react'

type Props = {
  isOpen: boolean
  title: string
  message: string
  type: 'success' | 'error'
  countdown?: number
  onClose?: () => void
}

export const Modal = ({ isOpen, title, message, type, countdown, onClose }: Props) => {
  if (!isOpen) return null

  const bgColor = type === 'success' ? '#28a745' : '#dc3545'
  const icon = type === 'success' ? '✓' : '✕'

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10000,
      }}
    >
      <div
        className="card"
        style={{
          width: '400px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div
          className="card-header text-white"
          style={{
            backgroundColor: bgColor,
            borderBottom: 'none',
            padding: '20px',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '48px', marginBottom: '10px' }}>{icon}</div>
          <h5 className="mb-0">{title}</h5>
        </div>
        <div className="card-body" style={{ padding: '20px', textAlign: 'center' }}>
          <p className="mb-0">{message}</p>
          {countdown !== undefined && countdown > 0 && (
            <p style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>Redirecting in {countdown} seconds...</p>
          )}
        </div>
        {type === 'error' && onClose && (
          <div className="card-footer" style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
            <button className="btn btn-secondary btn-block" onClick={onClose}>
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
